var ReactElementFactory = /** @class */ (function () {
    function ReactElementFactory() {
        this.creatorHash = {};
    }
    ReactElementFactory.prototype.registerElement = function (elementType, elementCreator) {
        this.creatorHash[elementType] = elementCreator;
    };
    ReactElementFactory.prototype.getAllTypes = function () {
        var result = new Array();
        for (var key in this.creatorHash) {
            result.push(key);
        }
        return result.sort();
    };
    ReactElementFactory.prototype.isElementRegistered = function (elementType) {
        return !!this.creatorHash[elementType];
    };
    ReactElementFactory.prototype.createElement = function (elementType, params) {
        var creator = this.creatorHash[elementType];
        if (creator == null)
            return null;
        return creator(params);
    };
    ReactElementFactory.Instance = new ReactElementFactory();
    return ReactElementFactory;
}());
export { ReactElementFactory };
